import {
  CalendarCheck,
  Compass,
  Heart,
  Home,
  HeartPulse,
  PawPrint,
  Search,
  ShoppingBag,
  Store,
  UtensilsCrossed,
  Bookmark,
  MapPin,
  Wrench,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AppShell, type ShellNavItem } from '@/components/app-shell';
import { use_session_store } from '@/lib/session-store';

const NAV: ShellNavItem[] = [
  // Aggregated landing tabs — the primary end-user experience, one API call each.
  { to: '/app/home', label: 'Home', icon: Home, testid: 'nav-home' },
  { to: '/app/food-cafe', label: 'Food & Cafe', icon: UtensilsCrossed, testid: 'nav-food-cafe' },
  { to: '/app/services', label: 'Services', icon: Wrench, testid: 'nav-services' },
  { to: '/app/health', label: 'Health', icon: HeartPulse, testid: 'nav-health' },
  // Utility destinations the tabs link into.
  { to: '/app/pets', label: 'My Pets', icon: PawPrint, testid: 'nav-my-pets' },
  { to: '/app/search', label: 'Search', icon: Search, testid: 'nav-search' },
  { to: '/app/discover', label: 'Find services', icon: Compass, testid: 'nav-find-services' },
  { to: '/app/shop', label: 'Shop', icon: Store, testid: 'nav-shop' },
  { to: '/app/adopt', label: 'Adopt', icon: Heart, testid: 'nav-adopt' },
  { to: '/app/saved', label: 'Wishlist', icon: Bookmark, testid: 'nav-saved' },
  { to: '/app/addresses', label: 'My Addresses', icon: MapPin, testid: 'nav-addresses' },
  { to: '/app/bookings', label: 'My Bookings', icon: CalendarCheck, testid: 'nav-my-bookings' },
  { to: '/app/orders', label: 'My Orders', icon: ShoppingBag, testid: 'nav-my-orders' },
];

export function UserShell() {
  const navigate = useNavigate();
  const phone = use_session_store((s) => s.phone);
  const clear = use_session_store((s) => s.clear);

  function handle_sign_out() {
    // Navigate to the front door FIRST so the /app route (and its role guard)
    // unmounts before the session clears — otherwise the guard re-renders on
    // the cleared session and redirects to /user/login, beating us to it.
    navigate('/', { replace: true });
    clear();
  }

  return (
    <AppShell
      brandIcon={PawPrint}
      brandTitle="Pet Owner"
      nav={NAV}
      phone={phone}
      bookingPath="/app/bookings"
      profilePath="/app/profile"
      onSignOut={handle_sign_out}
      navTestId="user-nav"
      mainTestId="user-main"
      maxWidthClass="max-w-5xl"
    />
  );
}
